// extracted by mini-css-extract-plugin
export default {"container":"landing_container__VPmNN","login":"landing_login__mj-Sg","signup":"landing_signup__S8zUn","box1":"landing_box1__3-ugO","box2":"landing_box2__AaZga"};